<template>
  <div class="container-fluid parent">
    <div class="container">
      <div class="row">
        <div class="col header">
          <div class="logo">
            <router-link
              to="/booking"
              custom
              v-slot="{ href, route, navigate, isActive, isExactActive }"
            >
              <img
                @click="navigate"
                :src="apidata.system.logo_url"
                alt="Logo"
              />
            </router-link>
          </div>
          <div class="menu" v-if="apidata.me">
            <router-link
              to="/reports"
              v-if="
                apidata.me.properties.tac_role === 'manager' &&
                  (apidata.me.properties.tac_organisation ===
                    apidata.system.organisation_id ||
                    apidata.me.properties.tac_organisation === 'superior_press')
              "
              >Reports</router-link
            >
            <router-link
              to="/reps"
              v-if="apidata.me.properties.tac_role === 'manager'"
              >Rep Management</router-link
            >
            <router-link
              :to="`/reps/${apidata.me.id}`"
              v-if="apidata.me.properties.tac_role === 'rep'"
              >My Profile</router-link
            >
            <router-link to="/tickets">Ticket Management</router-link>
            <a
              :href="apidata.system.bug_report_url"
              target="_blank"
              v-if="apidata.system.bug_report_url"
              >Report a bug</a
            >
            <router-link to="/logout">Logout</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {};
  },
};
</script>

<style scoped>
.logo img {
  height: 40px;
  cursor: pointer;
}

.parent {
  background-color: var(--primary-color);
  padding: 15px 0;
  margin-bottom: 50px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
}

.menu {
  display: flex;
  gap: 20px;
  overflow-y: auto;
}

.menu a {
  color: rgba(255, 255, 255, 0.541);
  text-decoration: none;
}

.menu a.router-link-active,
.menu a:hover {
  color: white;
  border-bottom: 1px solid white;
}
</style>
